import { render, staticRenderFns } from "./AddOrg.vue?vue&type=template&id=3cf95d08&scoped=true&"
import script from "./AddOrg.vue?vue&type=script&lang=js&"
export * from "./AddOrg.vue?vue&type=script&lang=js&"
import style0 from "./AddOrg.vue?vue&type=style&index=0&id=3cf95d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf95d08",
  null
  
)

export default component.exports